package com.fireavert.fire_risk.client

import com.fireavert.common.Try
import com.fireavert.fire_risk.data_models.responses.TenantFireRiskResponse
import com.fireavert.logging.Logger
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

class TenantFireRiskDataSourceImpl(
    private val baseUrl: String,
    private val httpClient: HttpClient,
    private val logger: Logger
) : TenantFireRiskDataSource {
    override suspend fun getTenantFireRiskByPropertyList(
        propertyId: Int?,
        token: String
    ): Try<TenantFireRiskResponse> {
        return Try.fromCoCallable {
            val response = httpClient.get {
                header("Authorization", "Bearer $token")
                url("$baseUrl/fireRiskScore/getRatings/$propertyId")
            }
            if (response.status.isSuccess()) response.body() else {
                throw Exception("Failed to get tenant fire risk data")
            }
        }
    }
}